export default __webpack_public_path__ + "static/media/404.693f268b.png";